export const state = () => ({
    lobalUrl: "/saas",      //全局
    fileUrl: '/standalonfile',

    webbUrl: `/web/bbs`,
    webUrl: `/web`
})

export const mutations = {
    
}

export const getters = {
    
}
